import ThirdOverview from './ThirdOverview'

class ClientOverview extends ThirdOverview {

    constructor(){
        super()
        this.linkedtype = 'client'
        this.setMappingName()
    }
}

export default ClientOverview